import { ApiV1 } from "./Api";

const novoPalestrante = (formData) => {
  const form = new FormData();
  form.append("name", formData.name);
  form.append("institution", formData.institution);
  form.append("photo", formData.photo);
  return ApiV1().post("/palestrantes", form);
};

const listarPalestrantes = () => {
  return ApiV1().get("/palestrantes");
};

const palestranteById = (idPalestrante) => {
  return ApiV1().get(`/palestrantes/${idPalestrante}`);
};

const updatePalestrante = (formData) => {
  const form = new FormData();
  form.append("name", formData.name);
  form.append("institution", formData.institution);
  form.append("photo", formData.photo);
  return ApiV1().patch(`/palestrantes/${formData._id}`, form);
};

const deletePalestrante = (idPalestrante) => {
  return ApiV1().delete(`/palestrantes/${idPalestrante}`);
};

export {
  novoPalestrante,
  listarPalestrantes,
  updatePalestrante,
  deletePalestrante,
  palestranteById,
};
